// Packages
import type { User } from '@nuinalp/cms-sdk-js';

export const useUserStore = defineStore('user', () => {
  const info = ref<User.IModel>();

  const name = computed(() => info.value?.id ? `${info.value.first_name} ${info.value.last_name}` : '');

  const isAdmin = computed(() => ['superadmin', 'admin'].includes(info.value?.type || ''))

  function setInfo(newUser: User.IModel) {
    info.value = newUser;
  }

  return { info, setInfo, name, isAdmin }
})